// import globalCofig from "@/setting/setting";
import { encBlackList } from "@/app/shop/api/shopping";
// import crypto from "@/basa/utils/crypto";
export const mixinHomePage = {
  data() {
    return {};
  },
  deactivated() {},
  methods: {
    //我要报名
    signUp(row) {
      console.log(localStorage.usedSupInfo)
      debugger;
      if (this.checkFlag === "5") {
        this.$message({
          showClose: true,
          message: "该公告您已报过名了",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
        return false;
      }
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          JSON.parse(localStorage.usedSupInfo)?.secretAgentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_CRMSA_URL
            )}/bid/shop/participateSub?schemeId=${row.schemeId}&purchaseType=${
              row.purchaseType
            }&noticeStartTime=${
              // encodeURIComponent(
            new Date(row.noticeStartTime).getTime()
            // row.noticeStartTime
          // )
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}&supCode=${
              row.supCode
            }&supName=${row.supName}&a=${
              JSON.parse(localStorage.usedSupInfo)?.secretAgentId
            }`
          ),
        "_blank"
      );
      // let query = {
      //   schemeId: row.schemeId,
      //   purchaseType: row.purchaseType,
      //   noticeStartTime: row.noticeStartTime,
      //   schemeName: encodeURIComponent(row.schemeName),
      //   schemeCode: encodeURIComponent(row.schemeCode),
      //   supCode: row.supCode,
      //   // supName: row.supName,
      //   a: globalCofig.agentId
      // }
      // console.log(query)
      // console.log(crypto.Encrypt(JSON.stringify(query)))
      // debugger;
      // window.open(
      //   this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
      //   "?CLIENT_ID=" +
      //   globalCofig.agentId +
      //   "&CALLBACK_URL=" +
      //   encodeURIComponent(
      //     `${this.$addUrlPerFix(
      //         process.env.VUE_APP_BID_URL
      //       )}/shop/participateSub?__params=` + crypto.Encrypt(JSON.stringify(query))
      //   ),
      //   "_blank"
      // );
    },
    toProject(obj) {
      window.open(
        `${this.$addUrlPerFix(
          process.env.VUE_APP_CRMSA_URL
        )}/bid/bidFlowIndexSub?schemeId=${obj.schemeId}&noticeStartTime=${
          obj.noticeStartTime
        }&noticeEndTime=${obj.noticeEndTime}&schemeName=${
          obj.schemeName
        }&schemeCode=${obj.schemeCode}${
          obj.supCode ? "&supCode=" + obj.supCode : ""
        }&supName=${obj.supName}&purchaseType=${
          obj.purchaseType
        }&supplierFlag=1&a=${
          JSON.parse(localStorage.usedSupInfo)?.secretAgentId
        }`
      );
    },
    //进入项目
    perform(row) {
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
          "?CLIENT_ID=" +
          JSON.parse(localStorage.usedSupInfo)?.secretAgentId +
          "&CALLBACK_URL=" +
          encodeURIComponent(
            `${this.$addUrlPerFix(
              process.env.VUE_APP_CRMSA_URL
            )}/bid/bidFlowIndexSub?schemeId=${row.schemeId}&noticeStartTime=${
              row.noticeStartTime
            }&schemeName=${encodeURIComponent(
              row.schemeName
            )}&schemeCode=${encodeURIComponent(row.schemeCode)}${
              row.supCode ? "&supCode=" + row.supCode : ""
            }&supName=${encodeURIComponent(row.supName)}&a=${
              JSON.parse(localStorage.usedSupInfo)?.secretAgentId
            }`
          ),
        "_blank"
      );
    },
    //查看详情
    handleView(row) {
      debugger;
      if (row.supCode) {
        encBlackList({
          ids: [row.supCode],
          purchaseUnitId: Number(row.purchaseUnitId)
        }).then(res => {
          if (res.data.data.isJoin === "0") {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: res.data.data.errMsg,
              type: "error",
              showClose: true,
              ccuiCustom: true
            });
          } else {
            let obj = {
              schemeId: row.schemeId,
              noticeId: row.noticeId,
              opUnitName: row.opUnitName,
              opUnitId: row.opUnitId,
              purchaseType: row.purchaseType,
              schemeStatus: row.schemeStatus,
              supplierFlag: 1
            };

            if (row.checkFlag) {
              obj.checkFlag = row.checkFlag;
            }
            let objs = JSON.parse(localStorage.getItem("usedSupInfo"));
            console.log(objs, "obj...");
            if (row.supCode) {
              obj.supCode =
                row.supCode ||
                objs.supCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                "";
              obj.encSupCode =
                row.encSupCode ||
                objs.encSupCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                "";
              obj.supName =
                row.supName ||
                this.$route_query.supName ||
                objs.supName ||
                objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                "";
            }
            let url = this.$router.resolve({
              path: "/viewNoticeDetail",
              query: obj
            });
            window.open(url.href, "_blank");
          }
        });
      } else {
        let obj = {
          schemeId: row.schemeId,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType,
          schemeStatus: row.schemeStatus,
          supplierFlag: 1
        };
        if (row.checkFlag) {
          obj.checkFlag = row.checkFlag;
        }
        let objs = JSON.parse(localStorage.getItem("usedSupInfo"));
        console.log(objs, "obj...");
        if (row.supCode) {
          obj.supCode =
            row.supCode ||
            objs.supCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
            "";
          obj.encSupCode =
            row.encSupCode ||
            objs.encSupCode ||
            objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
            "";
          obj.supName =
            row.supName ||
            this.$route_query.supName ||
            objs.supName ||
            objs.getSupInfoByLoginInfoRspBOList[0].supName ||
            "";
        }
        let url = this.$router.resolve({
          path: "/viewNoticeDetail",
          query: obj
        });
        window.open(url.href, "_blank");
      }
    },
    //点击详情页面相关公告列表标题跳转
    handleNoticeTitle(row) {
      let type = 0;
      let isSimple = true;
      //18 -> 评标结果公示  13->流标  14->补遗  16，17 -> 中标通知
      switch (row.purStep) {
        case "13":
          type = "8";
          break;
        case "14":
          type = "7";
          break;
        case "16":
          type = "4";
          break;
        case "17":
          type = "4";
          break;
        case "18":
          type = "3";
          break;
        default:
          isSimple = false;
          break;
      }
      if (isSimple) {
        let url = this.$router.resolve({
          path: "/viewNoticeSimpleDetail",
          query: {
            type: type,
            schemeId: row.schemeId,
            noticeId: row.noticeId,
            opUnitName: row.opUnitName,
            supCode: this.$route_query.supCode,
            supName: this.$route_query.supName
          }
        });
        window.open(url.href, "_blank");
      } else {
        this.handleView(
          Object.assign({}, row, {
            supCode: this.$route_query.supCode,
            supName: this.$route_query.supName
          })
        );
      }
    },
    //点击首页类目名称进入搜索页，并带过去条件
    handleClickCategory(item) {
      let url = this.$router.resolve({
        path: "/searchList",
        query: {
          categoryCode: item.categoryCode,
          categoryName: encodeURIComponent(item.categoryName)
        }
      });
      window.open(url.href, "_blank");
    },

    //详情页面 该单位还在采购 点击更多
    handleViewCommendUnit(code) {
      let url = this.$router.resolve({
        path: "/searchList",
        query: {
          supCode: code
        }
      });
      window.open(url.href, "_blank");
    }

    //首页点击邀请公告跳转页面
    /*handleClickInviteNotice(item) {
      if (item.noticeStatus === "3" && item.checkFlag === "1") {
        this.signUp(item);
      } else if (item.checkFlag === "2" && item.schemeStatus === "3") {
        this.signUp(item);
      } else {
        this.perform(item);
      }
    }*/
  }
};
